<!--
aktuellen Status der Traplinked Fallen anzeigen
-->
<template>

  <div class="traplinkedStatusWrapper">

    <transition name="fade" mode="out-in">

      <div v-if="traplinkedDevices">

        <!-- Ergebnis Tabelle Filtern -->
        <div id="filter" class="row border-top mb-3 pt-3">

          <div class="col-md-11">

            <b-input-group size="sm">
              <b-form-input v-model="keyword"
                            type="search"
                            id="filterInput"
                            :placeholder="$t('message.positionen_filter')"
              />
              <b-input-group-append>
                <b-button :disabled="!keyword" @click="keyword = ''"><span class="oi oi-x"></span></b-button>
              </b-input-group-append>
            </b-input-group>

          </div>
          <div class="col-md-1 text-right">

            <b-form-group horizontal label="" class="">
              <b-form-select :options="pageOptions" v-model="perPage" size="sm" />
            </b-form-group>

          </div>

        </div>

        <div class="table-responsive">
          <b-table striped
                 id="traplinked-status-table"
                 small
                 :fields="fields"
                 :items="items"
                 :keyword="keyword"
                 :current-page="currentPage"
                 :per-page="perPage"
                 hover
                 :responsive="true">

          <template v-slot:cell(deviceStatus)="row">

            <span v-if="row.item.deviceStatus">
                <device-status v-model="row.item.deviceStatus"
                               :id="row.item.id"
                />
            </span>

          </template>
          <!-- SUPPORT-1210: nicht mehr last heartbeat sondern timestamp anzeigen (traplinkedStatus_letzte_meldung)
          <template v-slot:cell(lastHeartbeat)="row">

            <span v-if="row.item.lastHeartbeatTimestamp">
              <java-date-to-default-time-format v-model="row.item.lastHeartbeatTimestamp" />
            </span>

          </template>
          -->
          <template v-slot:cell(timestamp)="row">

            <span v-if="row.item.timestamp">
              <java-date-to-default-time-format v-model="row.item.timestamp" />
            </span>

          </template>
          <template v-slot:cell(batteryStatus)="row">

            <span v-if="row.item.batteryStatus != null">
              <batterie-status v-model="row.item.batteryStatus"/>
            </span>

          </template>

          <!-- schlechtes WLAN anzeigen -->
          <template v-slot:cell(unstableWifi)="row">

            <device-wifi v-model="row.item" />

          </template>

          <template v-slot:cell(position)="row">

            <position-of-traplinked-device v-model="row.item" v-on:set-position="setPosition" />

          </template>
          <template v-slot:cell(objekt)="row">

            <objekt-of-traplinked-device v-model="row.item" v-on:set-objekt="setObjekt" />

          </template>
          <template v-slot:cell(area)="row">

            <area-of-traplinked-device v-model="row.item" v-on:set-area="setArea" />

          </template>
          <template v-slot:cell(actions)="row">

            <span v-if="row.item.lastHeartbeat">
              <device-history v-if="row.item.id" v-model="row.item" />
            </span>

          </template>

        </b-table>
        </div>

        <b-row>
          <b-col md="12" class="my-1">
            <b-pagination :total-rows="totalRows"
                          :per-page="perPage"
                          v-model="currentPage"
                          class="my-0" />
          </b-col>
        </b-row>

      </div>

    </transition>

  </div>

</template>
<script>

  // Define a new component
  import axios from "axios";
  import PositionOfTraplinkedDevice from '@/components/traplinkedbericht/PositionOfTraplinkedDevice'
  import BatterieStatus from '@/components/traplinkedbericht/BatterieStatus'
  import DeviceHistory from '@/components/traplinkedbericht/DeviceHistory'
  import AreaOfTraplinkedDevice from '@/components/traplinkedbericht/AreaOfTraplinkedDevice'
  import JavaDateToDefaultTimeFormat from '@/components/layout/JavaDateToDefaultTimeFormat'
  import ObjektOfTraplinkedDevice from '@/components/traplinkedbericht/ObjektOfTraplinkedDevice.vue'
  import DeviceWifi from '@/components/traplinkedbericht/DeviceWifi.vue'
  import DeviceStatus from '@/components/traplinkedbericht/DeviceStatus.vue'

  export default {

    name: 'TraplinkedStatus',
    components: {
      DeviceStatus,
      ObjektOfTraplinkedDevice,
      BatterieStatus,
      PositionOfTraplinkedDevice,
      DeviceHistory,
      AreaOfTraplinkedDevice,
      JavaDateToDefaultTimeFormat,
      DeviceWifi,
    },
    props: ['value'],
    /*
      Defines the data used by the component
    */
    data: function () {
      return {
        /** Liste von Fallen eines Kunden */
        traplinkedDevices: null,
        fields: [
          {
            key: 'timestamp',
            label: this.$t('message.deviceHistory_zeitpunkt'),
            sortable: true,
            order: 10,
          },
          {
            key: 'name',
            label: this.$t('message.traplinkedStatus_24_7_name'),
            sortable: true,
            order: 20,
          },
          {
            key: 'objekt',
            label: this.$t('message.printErgebnisliste_objekt'),
            sortable: true,
            order: 30,
          },
          {
            key: 'position',
            label: this.$t('message.printPositionen_position'),
            sortable: true,
            order: 40,
          },
          {
            key: 'area',
            label: this.$t('message.printPositionen_bereich'),
            sortable: false,
            order: 50,
          },
          {
            key: 'deviceStatus',
            label: this.$t('message.traplinkedStatus_meldung'),
            sortable: true,
            order: 60,
          },
          {
            key: 'batteryStatus',
            label: this.$t('message.traplinkedStatus_batterie'),
            sortable: true,
            order: 70,
          },
          {
            key: 'unstableWifi',
            label: this.$t('message.traplinkedStatus_unstableWifi'),
            sortable: false,
            order: 80,
          },
          {
            key: 'actions',
            label: this.$t('message.traplinkedStatus_alt'),
            sortable: false,
            order: 100,
            class: 'text-right',
          }
        ],
        /** Filter Query String für Suche nach Position */
        keyword: '',
        /** Anzahl der Positionen die in der Tabelle angezeigt werden sollen */
        pageOptions: [ 5, 10, 15, 20, 50, 100 ],
        /** ausgewählter Wert aus den pageOptions */
        perPage: 20,
        /** Pagination der Ergebnistabelle */
        currentPage: 1
      }
    },
    computed: {

      items: function () {

        var lowercase = this.keyword ? this.keyword.toLowerCase() : null;

        var selectedRows = lowercase
            ? this.traplinkedDevices.filter( item =>
                (item.lastHeartbeat && this.javaDateToDefaultTimeFormat(item.lastHeartbeat).toLowerCase().includes(lowercase)) ||
                (item.name && item.name.toLowerCase().includes(lowercase)) ||
                (item.description && item.description.toLowerCase().includes(lowercase)) ||
                (item.locationName && item.locationName.toLowerCase().includes(lowercase)) ||
                (item.traplinkedId && item.traplinkedId.toLowerCase().includes(lowercase)) ||
                (item.position && item.position.positionsNr && item.position.positionsNr.toLowerCase().includes(lowercase))  ||
                (item.position && item.position.positionsBesch && item.position.positionsBesch.toLowerCase().includes(lowercase)) ||
                (item.objekt && item.objekt.bezeichnung && item.objekt.bezeichnung.toLowerCase().includes(lowercase)) ||
                (item.area && item.area.name && item.area.name.toLowerCase().includes(lowercase))
            )
            : this.traplinkedDevices;

        return selectedRows;

      },
      totalRows: function () {
        return this.items.length;
      }

    },
    watch: {

      value: function () {
        this.init()
      }

    },
    mounted: function () {

      this.init()

    },
    methods: {

      /** eine Area in die Liste der TraplinkedDevices zum Filtern eintragen */
      setArea: function (obj) {

        console.log('setArea' + obj);
        for (let i = 0; i < this.traplinkedDevices.length; i++) {
          if (this.traplinkedDevices[i].id == obj.traplinked_device_id) {
            this.traplinkedDevices[i].area = obj.area;
            break;
          }
        }

      },
      /** eine Position in die Liste der TraplinkedDevices zum Filtern eintragen */
      setPosition: function (obj) {

        console.log('setPosition' + obj);
        for (let i = 0; i < this.traplinkedDevices.length; i++) {
          if (this.traplinkedDevices[i].id == obj.traplinked_device_id) {
            this.traplinkedDevices[i].position = obj.position;
            break;
          }
        }

      },
      /** ein Objekt in die Liste der TraplinkedDevices zum Filtern eintragen */
      setObjekt: function (obj) {

        console.log('setObjekt', obj);
        for (let i = 0; i < this.traplinkedDevices.length; i++) {
          if (this.traplinkedDevices[i].id == obj.traplinked_device_id) {
            this.traplinkedDevices[i].objekt = obj.objekt;
            break;
          }
        }

      },
      /** hole alle Fallen des Kunden */
      init: function () {

        this.traplinkedDevices = null;
        // Traplinked ID für Admins anzeigen
        if (this.$store.getters.user_role && this.$store.getters.user_role.authority == this.ROLE_ADMIN) {
          this.fields.push (
              {
                key: 'traplinkedId',
                label: this.$t('message.positionDetails_seriennummer'),
                sortable: true,
                order: 15
              }
          );
          this.fields.sort((a, b) => a.order - b.order);
        }

        if (!this.value) {

          this.showSpinner();
          var customer = this.$store.getters.customer;
          var url     = process.env.VUE_APP_SERVER_URL + '/datenbroker/getTraplinkedDevices';
          var params  = {
            customer_id: customer.id
          }

          var that = this;
          axios({
            method: 'GET',
            params: params,
            url: url
          }).then(function (response) {

            if (response.data && response.data.traplinkedDevices instanceof Array) {

              that.traplinkedDevices = response.data.traplinkedDevices;
              that.hideSpinner();

            }

          }).catch(error => {
            console.log(error);
          })

        } else {

          this.traplinkedDevices = this.value

        }

      }

    }

  }

</script>
